import { useCallback, useState } from "react";

import { useBoundedRefetch } from "./useBoundedRefetch";

// The document → data-source link (ProcessedManifest.documentManifestId, which
// drives sourceDocument) is written by the process-manifests background job,
// which runs after extraction. The uploaded doc already shows immediately via
// pre-association; this poll catches its promotion to the data source (source
// dot, review action, pending-review banner) without a manual refresh.
export function useSourcePromotionPoll({
  hasSourceDocument,
  refetch,
}: {
  hasSourceDocument: boolean;
  refetch: () => void;
}) {
  // Bump the key after each extraction so another upload gets a fresh polling window.
  const [restartKey, setRestartKey] = useState(0);

  // Poll only while the manifest has no source document.
  useBoundedRefetch(restartKey > 0 && !hasSourceDocument, refetch, restartKey);

  return useCallback(() => {
    setRestartKey((key) => key + 1);
  }, []);
}
